import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import ReceiptBasicInfoComponent from './receipt-basic-info.component';
import ReceiptItemInfoComponent from './receipt-item-info.component';

export const ReceiptComponent = ({
  handleInnerFormChange, selectedReceipts, back, handleFormSubmit,
  voucherTransactionTypeList, paymentTransactionTypeList, ledgerTransactionTypeList,
  organizationUnitsList, ledgersList, invoiceNumbersList
}: any) => {

  const tabItems = [
    {
      id: 0,
      title: 'Receipt Basic Information',
      component: <ReceiptBasicInfoComponent
        handleInnerFormChange={handleInnerFormChange}
        selectedReceipts={selectedReceipts}
        voucherTransactionTypeList={voucherTransactionTypeList}
        paymentTransactionTypeList={paymentTransactionTypeList}
        ledgerTransactionTypeList={ledgerTransactionTypeList}
        organizationUnitsList={organizationUnitsList}
        ledgersList={ledgersList}
      />,
      isVisible: true,
    },
    {
      id: 1,
      title: 'Receipt Item Information',
      component: <ReceiptItemInfoComponent
        handleInnerFormChange={handleInnerFormChange}
        selectedReceipts={selectedReceipts}
        invoiceNumbersList={invoiceNumbersList}
      />,
      isVisible: true,
    },
  ]

  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">

      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}
          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  )
}

export default ReceiptComponent;
